/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Service for cryptographic operations like password hashing.
 * Designed for use in browser/frontend environments.
 */

/**
 * Hashes a string (like a password) using SHA-256.
 * Returns the hex representation of the hash.
 */
export const hashPassword = async (password: string): Promise<string> => {
    const encoder = new TextEncoder();
    const data = encoder.encode(password);
    
    // Hash the password using SHA-256
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    
    // Convert buffer to byte array
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    
    // Convert bytes to hex string
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    
    return hashHex;
};
